import React, { Suspense } from 'react'
import { Spinner } from 'components/Spinner'
import { setViewportFullHeight } from 'helpers/setViewportFullHeight'
import { useInitAppConfig } from 'hooks/useInitAppConfig'
import { useScrollFix } from 'hooks/useScrollFix'
import { polyfill as smoothScrollPolyfill } from 'smoothscroll-polyfill'
import { useSetOptimizeVariantMap } from 'hooks/useSetOptimizeVariantMap'
import { shallowEqual, useSelector } from 'react-redux'
import { selectUserStatus } from 'root-redux/selects/user'
import { selectConfig, selectCurrentVariant } from 'root-redux/selects/common'
import { useSetVariant } from 'hooks/useSetVariant'
import { useSetUuid } from 'hooks/useSetUuid'
import { useSetUserStatus } from 'hooks/useSetUserStatus'
import { LayoutProvider } from 'components/LayoutProvider'
import { useAnimatedBackground } from 'hooks/useAnimatedBackground'
import { useGoogleAnalytics } from 'hooks/useGoogleAnalytics'
import { browserHistory } from './browserHistory'
import { CustomRouter } from './CustomRouter'

setViewportFullHeight()
smoothScrollPolyfill()

export const App: React.FC = () => {
  const userStatus = useSelector(selectUserStatus, shallowEqual)
  const variant = useSelector(selectCurrentVariant, shallowEqual)
  const config = useSelector(selectConfig)

  useInitAppConfig()
  useGoogleAnalytics()
  useSetVariant()
  useSetUuid()
  useSetUserStatus()
  useScrollFix()
  useSetOptimizeVariantMap()
  useAnimatedBackground()

  return (
    <CustomRouter history={browserHistory}>
      <Suspense fallback={<Spinner />}>
        {userStatus && variant && config ? <LayoutProvider /> : <Spinner />}
      </Suspense>
    </CustomRouter>
  )
}
